// Angular Imports
import { Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
// Shared Imports
import { SnackbarComponent } from '@shared/components'
import { ISnackbar, ISnackbarCore, ESnackbarType, ISnackbarData } from '@shared/models'

@Injectable({
	providedIn: 'root',
})
export class SnackbarService {
	constructor(private _snackbar: MatSnackBar) {}

	open(snackbar: ISnackbar): void {
		this._core({
			...snackbar,
			type: ESnackbarType.green,
			classes: ['Snackbar', 'Snackbar--open'],
		})
	}

	success(snackbar: ISnackbar): void {
		this._core({
			...snackbar,
			type: ESnackbarType.success,
			classes: ['Snackbar', 'Snackbar--success'],
		})
	}

	warning(snackbar: ISnackbar): void {
		this._core({
			...snackbar,
			duration: 5000,
			type: ESnackbarType.warning,
			classes: ['Snackbar', 'Snackbar--warning'],
		})
	}

	error(snackbar: ISnackbar): void {
		this._core({
			...snackbar,
			duration: 5000,
			type: ESnackbarType.error,
			classes: ['Snackbar', 'Snackbar--error'],
		})
	}

	private _core({
		classes,
		type,
		message,
		hasIcon = false,
		action = '',
		duration = 2500,
		horizontalPosition = 'center',
		verticalPosition = 'bottom',
	}: ISnackbarCore): void {
		const data: ISnackbarData = { message, type, action, hasIcon }
		this._snackbar.openFromComponent(SnackbarComponent, {
			horizontalPosition,
			verticalPosition,
			duration,
			data,
			panelClass: classes,
		})
	}
}
